import { WebApiError } from "./web-api-error";

// In case of HTTP response outside of 200-299 range
async function checkForHTTPError(
  response: Response,
  errorRedirectUrl = "/registrering/nb",
): Promise<Response> {
  if (response.ok || response.status === 409) {
    return response;
  } else if (response.status === 401) {
    window.location.href = errorRedirectUrl;
    return response;
  } else {
    const contentType = response.headers.get("content-type");

    if (contentType && contentType.indexOf("text/plain") !== -1) {
      const errorText = await response.text();
      throw new WebApiError(response.status, errorText);
    } else {
      const errorJson = await response.json();
      throw new WebApiError(
        response.status,
        errorJson["error-code"],
        errorJson["error-message"],
        errorJson["link"],
      );
    }
  }
}

export async function get(
  uri: string,
  errorRedirectUrl?: string,
): Promise<Response> {
  const response = await fetch(uri, { credentials: "same-origin" });
  return await checkForHTTPError(response, errorRedirectUrl);
}

export async function getJSON<T>(
  uri: string,
  errorRedirectUrl?: string,
): Promise<T> {
  return (await (await get(uri, errorRedirectUrl)).json()) as T;
}

export async function request(
  method: "GET" | "PUT" | "POST" | "PATCH" | "DELETE",
  csrfToken: string | undefined,
  uri: string,
  body?: Record<string, unknown>,
  errorRedirectUrl?: string,
  headers?: Record<string, string>,
): Promise<Response> {
  const response = await fetch(uri, {
    method: method,
    credentials: "same-origin",
    body: body ? JSON.stringify(body) : undefined,
    headers: {
      Accept: "application/vnd.digipost-v2+json",
      "Content-Type": "application/vnd.digipost-v2+json",
      "X-CSRF-TOKEN": csrfToken || "",
      ...headers,
    },
  });
  return await checkForHTTPError(response, errorRedirectUrl);
}

export function post(
  uri: string,
  body?: Record<string, unknown>,
  csrfToken?: string,
  errorRedirectUrl?: string,
): Promise<Response> {
  return request("POST", csrfToken, uri, body, errorRedirectUrl);
}

export function put(
  uri: string,
  body?: Record<string, unknown>,
  csrfToken?: string,
): Promise<Response> {
  return request("PUT", csrfToken, uri, body);
}

export function remove(
  uri: string,
  csrfToken?: string,
  headers?: Record<string, string>,
): Promise<Response> {
  return request("DELETE", csrfToken, uri, {}, undefined, headers);
}
